import React, { createContext, useState, useEffect } from "react";
import { exchangeRefreshToken } from "../util/auth";

export const AuthContext = createContext({
  token: "",
  isAuthenticated: false,
  userName: "",
  role: "",
  userId: "",
  authenticate: () => {},
  logout: () => {},
  currentDoctor: {
    name: null,
    lastName: null,
    surName: null,
    speciality: null,
    cardId: null,
    email: null,
    cellPhone: null,
    key: null,
  },
  storeCurrentDoctor: (doctor) => {},
});

function AuthContextProvider({ children }) {
  const [authToken, setAuthToken] = useState("");
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState("");
  const [currentDoctor, setCurrentDoctor] = useState({});

  async function CheckValidity() {
    const token = await localStorage.getItem("token");
    if (!token) {
      logout();
      return;
    } else {
      await refreshToken();
    }
  }

  function storeCurrentDoctor(doctor) {
    setCurrentDoctor(doctor);
  }

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      CheckValidity();
    }, 60 * 45 * 1000);

    return () => clearInterval(refreshInterval);
  });

  async function authenticate({
    token,
    refreshToken,
    expireDate,
    userName,
    role,
    userId,
  }) {
    setAuthToken(token);
    setUserName(userName);
    setRole(role);
    setUserId(userId);

    localStorage.setItem("expireDate", expireDate);
    localStorage.setItem("token", token);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("userName", userName);
    localStorage.setItem("role", role);
    localStorage.setItem("userId", userId);
  }

  function logout() {
    setAuthToken(null);
    setUserName(null);
    setRole(null);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expireDate");
    localStorage.removeItem("userName");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
  }

  async function refreshToken() {
    const storedRefreshToken = await localStorage.getItem("refreshToken");
    const userId = await localStorage.getItem("userId");
    const response = await exchangeRefreshToken(storedRefreshToken, userId);
    authenticate(response);
  }

  const value = {
    token: authToken,
    isAuthenticated: !!authToken,
    username: userName,
    role: role,
    userId: userId,
    authenticate,
    logout,
    currentDoctor,
    storeCurrentDoctor: storeCurrentDoctor,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthContextProvider;
